import styled from "styled-components"

export const ButtonWrapper = styled.div`
  position: absolute;
  right: ${({theme}) => theme.spacing.two};
  z-index: 1000;
`
